import { AdminBreadcrumb } from "./-components/admin-breadcrumb"
import { AdminSidebar } from "./-components/admin-sidebar"
import { UserButton } from "@clerk/clerk-react"
import { createFileRoute, Outlet, Navigate, Link } from "@tanstack/react-router"

import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar"
import { Button } from "@/components/ui/button"
import { api } from "@convex/_generated/api"
import { useQuery } from "convex/react"

export const Route = createFileRoute("/(admin)/admin")({
  component: RouteComponent,
})

function RouteComponent() {
  const isAdmin = useQuery(api.users.handlers.isAdmin, {})

  // Show loading state while checking admin status
  if (isAdmin === undefined) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }

  // Redirect if not admin
  if (!isAdmin) {
    return <Navigate to="/app" replace />
  }

  // Render admin layout
  return (
    <SidebarProvider>
      <AdminSidebar />
      <SidebarInset>
        <header className="bg-background sticky top-0 z-10 flex w-full items-center justify-between gap-2 border-b px-4 py-3">
          <div className="flex items-center gap-2">
            <SidebarTrigger />
            <AdminBreadcrumb />
          </div>
          <div className="flex items-center gap-2">
            <Link to="/app">
              <Button variant="outline" size="sm">
                Dashboard
              </Button>
            </Link>
            <UserButton />
          </div>
        </header>
        <Outlet />
      </SidebarInset>
    </SidebarProvider>
  )
}
